export { SWComparisonTable } from './SWComparisonTable';
